/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['underscore', './YoutubeVideoLoader', './EmbedMediaLoader'], function(_, YoutubeVideoLoader, EmbedMediaLoader) {


	const loaders = [new YoutubeVideoLoader('youtube'), new EmbedMediaLoader('embedMedia')];
	const loaderMap = {};

	_.each(loaders, (loader) => {
		loaderMap[loader.type] = loader;
	});

	class MediaResolver {
		static loadFromUrl( url ) {
			let media = null;
			_.find(loaders, (loader) => {
				media = loader.tryToLoad(url);
				return media;
			});
			return media;
		}

		static loadFromModel(model){
			if (model.mediaType && loaderMap[model.mediaType]){
				return loaderMap[model.mediaType].tryToLoad(model.mediaLink);
			}else{
				return MediaResolver.loadFromUrl(model.mediaLink);
			}
		}
	}

	return MediaResolver;
});